import gql from 'graphql-tag';

export const GET_MEMBER = gql`
    query ($member_no: ID!) {
        getMember(member_no: $member_no)
        {
            member_no
            family_name
            given_name
            gender
            birth_date
            mobile_number
            email
            member_rank
            family_name_kana
            given_name_kana
            zipcode
            address1
            address2
        }
    },
`;
export const GET_GOLFGROUP = gql`
    query {
        golfGroup{
            golf_group_code
            golf_group_name
        }
    }
`;
export const REGISTER_MEMBER = gql`
    mutation (
      $family_name: String!,
      $given_name: String!,
      $gender: Int!,
      $birth_date: String!,
      $mobile_number: String,
      $email: String!,
      $password: String!,
      $member_rank: Int!,
      $family_name_kana: String,
      $given_name_kana: String,
      $zipcode: String,
      $address1: String,
      $address2: String
    ) {
        adminCreateMember (
          family_name: $family_name,
          given_name: $given_name,
          gender: $gender,
          birth_date: $birth_date,
          mobile_number: $mobile_number,
          email: $email,
          password: $password,
          member_rank: $member_rank,
          family_name_kana: $family_name_kana,
          given_name_kana: $given_name_kana,
          zipcode: $zipcode,
          address1: $address1,
          address2: $address2
        ) {
            result
            member_no
        }
    }
`;
export const UPDATE_MEMBER = gql`
    mutation (
      $member_no: ID!,
      $family_name: String!,
      $given_name: String!,
      $gender: Int!,
      $birth_date: String!
      $mobile_number: String,
      $email: String!,
      $member_rank: Int!,
      $family_name_kana: String,
      $given_name_kana: String,
      $zipcode: String,
      $address1: String,
      $address2: String
      ) {
        adminUpdateMember (
          member_no: $member_no,
          family_name: $family_name,
          given_name: $given_name,
          gender: $gender,
          birth_date: $birth_date,
          mobile_number: $mobile_number,
          email: $email,
          member_rank: $member_rank,
          family_name_kana: $family_name_kana,
          given_name_kana: $given_name_kana,
          zipcode: $zipcode,
          address1: $address1,
          address2: $address2
        ) {
            result
        }
    }
`;
export const DELETE_MEMBER = gql`
    mutation ( $member_no: ID!) {
        adminDeleteMember ( member_no: $member_no ) {
            result
        }
    }
`;

export const GET_MEMBER_LIST_FROM_POINT_BULK_REGIST = gql`
    query(
        $gender: Int!
        $birthdateFrom: String
        $birthdateTo: String
        $registdateFrom: String
        $registdateTo: String
    ){
        getMemberListFromPointBulkRegist(
            gender: $gender
            birthdateFrom: $birthdateFrom
            birthdateTo: $birthdateTo
            registdateFrom: $registdateFrom
            registdateTo: $registdateTo
        ){
            MemberList{
                member_no
                family_name
                given_name
                gender
                birth_date
                mobile_number
                created_at
            }
            count
        }
    }
`;

export const GET_MY_PROFILE = gql`
  query($member_no: ID!) {
    getMyProfile(
      member_no: $member_no
    ){
      Profile{
        era
        family_name
        given_name
        email
        score_level
        profile
        gender
      }
    }
  }
`;

export const GET_REPRESENTATIVE_PROFILE = gql`
  query($reserve_no: String!) {
    getRepresentativeProfile(
        reserve_no: $reserve_no
    ){
      Profile{
        family_name
        given_name
        nickname
        email
        mobile_number
        gender
        era
        profile
        score_level
        member_class
      }
    }
  }
`;

export const GET_EMAIL_SEARCH_MEMBER_CLASS = gql`
query($email: String
      $golf_group_code: String)
    {
    GetEmailSearchMemberClass(
        email: $email
        golf_group_code: $golf_group_code
    ){
        member_class
    }
}
`;

export const GET_MEMBER_PROFILE = gql`
  query($member_no: ID!) {
    getMyProfileFromAdmin(
      member_no: $member_no
    ){
      Profile{
        era
        family_name
        given_name
        email
        score_level
        profile
      }
    }
  }
`;
